
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.002 32a22.815 22.815 0 01-16.254-6.76A22.924 22.924 0 010 8.957a8.944 8.944 0 012.212-5.959A8.915 8.915 0 017.82.022a2.552 2.552 0 011.585.307c.482.281.859.713 1.073 1.229l3.195 7.399a2.564 2.564 0 01-.205 2.56l-2.555 4.071a12.253 12.253 0 005.545 5.556l3.988-2.56a2.681 2.681 0 011.277-.538c.428-.038.86.032 1.253.205l7.463 3.2c.505.22.927.596 1.2 1.075.3.472.418 1.036.333 1.588a8.94 8.94 0 01-2.975 5.667 8.91 8.91 0 01-5.996 2.218zM8.128 2.555A6.463 6.463 0 004.14 4.681a6.382 6.382 0 00-1.585 4.276 20.5 20.5 0 005.98 14.44 20.556 20.556 0 0014.466 6.042 6.357 6.357 0 004.217-1.587 6.48 6.48 0 002.173-4.046l-7.54-3.2-3.987 2.56c-.364.28-.796.457-1.252.512-.44.051-.884-.029-1.278-.23a14.734 14.734 0 01-6.824-6.81 2.564 2.564 0 01.179-2.56l2.556-4.071-3.118-7.45z","fill":"currentColor"}})])
          )
        }
      }
    